// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}
:host .search-bar-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}
:host .aside-container {
  align-items: center;
  display: flex;
  flex-shrink: 0;
}
:host .close-icon {
  height: 24px;
}

.title {
  white-space: nowrap;
}

.add-button {
  margin-right: auto;
}

.search {
  position: relative;
  width: 100%;
}

.sort-options {
  align-items: center;
  margin-left: auto;
}
.sort-options .label {
  white-space: nowrap;
  margin-right: 1rem;
}

.date-filter {
  margin-left: auto;
  min-width: 380px;
  width: 450px;
}

:host ::ng-deep {
  /* stylelint-disable-next-line selector-max-compound-selectors */
}
:host ::ng-deep .mat-mdc-form-field-icon-suffix button,
:host ::ng-deep .mat-mdc-form-field-icon-prefix {
  align-items: center;
  display: flex;
  height: 36px;
  justify-content: center;
  width: 36px;
}
:host ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.sort {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  margin-right: 24px;
  white-space: nowrap;
}
.sort mat-form-field {
  margin-left: 10px;
}
.sort .mat-select-arrow {
  color: var(--app-black);
}

.buttons {
  margin-left: auto;
  margin-right: 0;
}
.buttons > :not(:last-child) {
  margin-right: 16px;
}

.button-prefix {
  margin-right: 4px;
}

.search-loading-option {
  display: flex;
  align-items: center;
  justify-content: center;
}

mat-button-toggle-group {
  align-items: center;
  height: 30px;
}

.filter-dropdown {
  min-width: 180px;
}

/* stylelint-disable-next-line */
mat-button-toggle spx-icon ::ng-deep mat-icon {
  height: 18px;
  margin-right: 8px;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./libs/shared/ng/common/src/lib/components/search-bar/search-bar.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AACJ;AAEE;EACE,mBAAA;EACA,aAAA;EACA,cAAA;AAAJ;AAGE;EACE,YAAA;AADJ;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,WAAA;AAFF;;AAKA;EACE,mBAAA;EACA,iBAAA;AAFF;AAIE;EACE,mBAAA;EACA,kBAAA;AAFJ;;AAMA;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;AAHF;;AAMA;EACE,gEAAA;AAHF;AAIE;;EAEE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;AAFJ;AAKE;EACE,aAAA;AAHJ;;AAOA;EACE,mBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAJF;AAME;EACE,iBAAA;AAJJ;AAOE;EACE,uBAAA;AALJ;;AASA;EACE,iBAAA;EACA,eAAA;AANF;AAQE;EACE,kBAAA;AANJ;;AAUA;EACE,iBAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,mBAAA;EACA,YAAA;AAPF;;AAUA;EACE,gBAAA;AAPF;;AAUA,gCAAA;AACA;EACE,YAAA;EACA,iBAAA;AAPF;AACA,g/GAAg/G","sourcesContent":[":host {\n  display: block;\n\n  .search-bar-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 24px;\n  }\n\n  .aside-container {\n    align-items: center;\n    display: flex;\n    flex-shrink: 0;\n  }\n\n  .close-icon {\n    height: 24px;\n  }\n}\n\n.title {\n  white-space: nowrap;\n}\n\n.add-button {\n  margin-right: auto;\n}\n\n.search {\n  position: relative;\n  width: 100%;\n}\n\n.sort-options {\n  align-items: center;\n  margin-left: auto;\n\n  .label {\n    white-space: nowrap;\n    margin-right: 1rem;\n  }\n}\n\n.date-filter {\n  margin-left: auto;\n  min-width: 380px;\n  width: 450px;\n}\n\n:host ::ng-deep {\n  /* stylelint-disable-next-line selector-max-compound-selectors */\n  .mat-mdc-form-field-icon-suffix button,\n  .mat-mdc-form-field-icon-prefix {\n    align-items: center;\n    display: flex;\n    height: 36px;\n    justify-content: center;\n    width: 36px;\n  }\n\n  .mat-mdc-form-field-subscript-wrapper {\n    display: none;\n  }\n}\n\n.sort {\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  margin-right: 24px;\n  white-space: nowrap;\n\n  mat-form-field {\n    margin-left: 10px;\n  }\n\n  .mat-select-arrow {\n    color: var(--app-black);\n  }\n}\n\n.buttons {\n  margin-left: auto;\n  margin-right: 0;\n\n  > :not(:last-child) {\n    margin-right: 16px;\n  }\n}\n\n.button-prefix {\n  margin-right: 4px;\n}\n\n.search-loading-option {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nmat-button-toggle-group {\n  align-items: center;\n  height: 30px;\n}\n\n.filter-dropdown {\n  min-width: 180px;\n}\n\n/* stylelint-disable-next-line */\nmat-button-toggle spx-icon ::ng-deep mat-icon {\n  height: 18px;\n  margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
